import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider, UIProvider } from "./contexts";
import { RecoilRoot } from "recoil";
import Aos from "aos";
import "aos/dist/aos.css";
import { AdminRouter } from "./router/AdminRouter";
import { WebRouter } from "./router/WebRouter";

function LoadingFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#151C84] mx-auto mb-4" />
        <p className="text-gray-500">Cargando...</p>
      </div>
    </div>
  );
}

function AppRoutes() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        <Route path="/admin/*" element={<AdminRouter />} />
        <Route path="/*"       element={<WebRouter />} />
      </Routes>
    </Suspense>
  );
}

function App() {
  Aos.init({ duration: 1800, offset: 0 });
  return (
    <RecoilRoot>
      <AuthProvider>
        <UIProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </UIProvider>
      </AuthProvider>
    </RecoilRoot>
  );
}

export default App;
